import type { Dispatch, SetStateAction } from 'react';
import { createContext, useContext } from 'react';

export const NavigationContext = createContext<{ stack: string[]; setStack: Dispatch<SetStateAction<string[]>> }>({
  stack: [],
  setStack: () => {},
});

export const useNavigationContext = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigationContext must be used within a NavigationProvider');
  }
  return context;
};
